import { RESOURCE } from "../../../../routes/const";

export default () => {
  const rules = [];
  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.licensingPrimary,
  });
  rules.push({
    action: "manage",
    subject: RESOURCE.creative.nested.licensingSecondary,
  });
  return rules;
};
